import { Drawer, DrawerProps } from "antd";
import React, { PropsWithChildren } from "react";
import "./styles.scss";

export type CustomDrawerProps = DrawerProps & PropsWithChildren & {};

const CustomDrawer: React.FC<CustomDrawerProps> = ({ children, ...props }) => {
  return (
    <Drawer
      className="menu-drawer"
      placement={"right"}
      closable={true}
      size={"large"}
      {...props}
    >
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
